import { categoryIcon } from "@/api/utils";

/** Small component to display the category icon */

export function CategoryIcon({ category }: { category: string; }) {
    if (categoryIcon(category)) {
        return <img src={categoryIcon(category) ?? ''} alt="Task Icon" className="w-4 h-4 mr-2 dark:invert" />;
    } else {
        return null;
    }
}
